import React from 'react';
import { CFormCheck, CFormFeedback, CFormLabel } from '@coreui/react-pro';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DEFAULT_FN } from '../../../constants';

import TooltipWithIcon from '../Tooltips/TooltipWithIcon';

const SimpleCheckboxGroup = ({
     id = '',
     className,
     name,
     label,
     contentToolTip,
     isRequired,
     isValidate,
     value,
     error,
     setFieldValue,
     disabled,
     onChange,
}) => {
     const handleChangeCheck = (e) => {
          setFieldValue(name, !value);
          onChange(e);
     };

     return (
          <div className={classNames('form-group simple-checkbox', { [className]: className })}>
               <div className={`d-flex align-items-center${(isRequired || isValidate) && !!error ? ' is-invalid' : ''}`}>
                    <CFormCheck
                         id={id}
                         name={name}
                         className={classNames('me-2 mt-0 mr-1', { 'cursor-pointer': !disabled })}
                         invalid={(isRequired || isValidate) && !!error}
                         checked={value}
                         onChange={handleChangeCheck}
                         disabled={disabled}
                    />
                    <CFormLabel htmlFor={id} className={classNames('d-flex align-items-center flex-1 mb-0', { 'cursor-pointer': !disabled })}>
                         {label && <span dangerouslySetInnerHTML={{ __html: label }} />}
                    </CFormLabel>
                    {contentToolTip && <TooltipWithIcon content={<div dangerouslySetInnerHTML={{ __html: contentToolTip }} />} trigger="click" />}
               </div>
               {(isRequired || isValidate) && (
                    <CFormFeedback className="px-0" invalid>
                         {error}
                    </CFormFeedback>
               )}
          </div>
     );
};

SimpleCheckboxGroup.propTypes = {
     name: PropTypes.string,
     label: PropTypes.string,
     contentToolTip: PropTypes.string,
     isRequired: PropTypes.bool,
     isValidate: PropTypes.bool,
     value: PropTypes.bool,
     error: PropTypes.string,
     disabled: PropTypes.bool,
     setFieldValue: PropTypes.func,
     onChange: PropTypes.func,
};

SimpleCheckboxGroup.defaultProps = {
     value: '',
     setFieldValue: DEFAULT_FN,
     onChange: DEFAULT_FN,
};

export default SimpleCheckboxGroup;
